import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { post, safeNext } from "@/lib/api";

export const NEXT_KEY = "tri-next";

export function startGoogle() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      const r = await post("/auth/google", { session_id: sid });
      let next = "/";
      try { next = safeNext(sessionStorage.getItem(NEXT_KEY)); sessionStorage.removeItem(NEXT_KEY); } catch (e) { /* storage off */ }
      if (r.ok) { window.location.replace(next); return; }
      setError(r.data.error || "Google sign-in failed.");
    })();
  }, [location.hash]);

  if (!error) return null;
  return (
    <main className="login-shell">
      <section className="login-card">
        <h1>Couldn't sign you in</h1>
        <div className="msg err" role="alert" data-testid="google-callback-error">{error}</div>
        <a className="link" href="/login" data-testid="google-callback-back">← Back to sign in</a>
      </section>
    </main>
  );
}
